import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import { Paper, Box, Typography, Fade, MenuItem, Chip, Collapse, Popover, InputAdornment, Dialog } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from "@material-ui/core/Checkbox";
import useStyles from './Styles/SearchStyles';
import placeholderImage from "../../../images/placeholderImage.jpg";
import PDFViewer from "../Staging/PDFViewer"
import DocumentGrid from "../Staging/DocumentGrid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Divider from '@material-ui/core/Divider';
import notify from "../../../utils/notifier";
import DocuwareTemplateService from "../../../services/DocuwareTemplateService";
import DocumentTabularView from "../DocumentTabularView";
import PaginationRoot from "../PaginationRoot";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { DateRange } from "react-date-range";
import enUS from "date-fns/locale/en-US";
import dayjs from "dayjs";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";



export default function Search ({ viewType , currentCompany}) {
    const classes = useStyles();
    const [searchKeys, setSearchKeys] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [documentType, setDocumentType] = useState([]);
    const [types, setTypes] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [searchTriggered, setSearchTriggered] = useState(false);
    const [searchValues, setSearchValues] = useState({});
    const [selectedDocuments, setSelectedDocuments] = useState(new Map());
    const [selectedDocumentsFileId, setSelectedDocumentsFileId] = useState(new Set());
    const [backdrop, setBackdrop] = useState(false);
    const [clientFields, setClientFields] = useState([]);
    const [refineExpanded, setRefineExpanded] = useState(false);
    const [searchPanelExpanded, setSearchPanelExpanded] = useState(true);
    const [systemFieldValues, setSystemFieldValues] = useState({
        document_name: "",
        uploaded_by: "",
        upload_date: ""
    });
    const [uploadDateAnchorEl, setUploadDateAnchorEl] = useState(null);
    const [uploadDateRange, setUploadDateRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection"
        }
    ]);
    const [documentNameAnchorEl, setDocumentNameAnchorEl] = useState(null);
    const [documentNameOptions, setDocumentNameOptions] = useState([]);
    const [documentNameLoading, setDocumentNameLoading] = useState(false);
    const [recentDocumentSearches, setRecentDocumentSearches] = useState([]);
    const [uploadedByAnchorEl, setUploadedByAnchorEl] = useState(null);
    const [uploadedByOptions, setUploadedByOptions] = useState([]);
    const [uploadedBySelectedUsers, setUploadedBySelectedUsers] = useState([]);
    const [uploadedBySearchText, setUploadedBySearchText] = useState("");
    const [uploadedByLoading, setUploadedByLoading] = useState(false);
    const [documentTypeSearchText, setDocumentTypeSearchText] = useState("");
    const [isResetConfirmOpen, setIsResetConfirmOpen] = useState(false);



    const [queryCount, setQueryCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');


    const normalizeKey = (label) => label.toLowerCase().replace(/\s+/g, '_');
    const systemFields = [
        {
            id: "document_name",
            label: "Document Name",
            aliases: ["document_name", "document", "name", "documenttitle", "document_title"]
        },
        {
            id: "uploaded_by",
            label: "Uploaded By",
            aliases: ["uploaded_by", "uploadedby", "created_by", "owner", "uploaded_user"]
        },
        {
            id: "upload_date",
            label: "Upload Date",
            aliases: ["upload_date", "uploaddate", "uploaded_date", "created_date", "date"]
        }
    ];

    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
        setPage(0);
        handleSearch(rowsPerPage, 0, property, isDesc ? "asc" : "desc");
    };

    const handleFilterSearch = filters => {
        setPage(0);
        handleSearch(rowsPerPage, 0, orderBy, order, filters);
    };

    const handleDocumentClick = (doc) => {
        setSelectedDoc((prevSelectedId) => (doc));
    };

    const handleSelectedDocs = (id, checked, fileIdentifier = null, name = null)  => {
        setSelectedDocuments(prev => {
            const newMap = new Map(prev);
            if (checked) {
              newMap.set(id, name || id);
            } else {
              newMap.delete(id);
            }
            return newMap;
          });

        if (fileIdentifier){
            setSelectedDocumentsFileId(prev => {
                const newSet = new Set(prev); 
                if (checked) {
                newSet.add(fileIdentifier);
                } else {
                newSet.delete(fileIdentifier); 
                }
                return newSet;
            });
        }
        
        
    }

    const transformedRefineValues = Object.entries(searchValues)
                                    .filter(([_, value]) => value?.trim()) 
                                    .map(([key, value]) => ({ key, value }));
    const transformedSystemValues = Object.entries(systemFieldValues)
                                    .filter(([_, value]) => value?.trim())
                                    .map(([key, value]) => ({ key, value }));
    const activeFiltersCount = transformedRefineValues.length + transformedSystemValues.length + (documentType.length > 0 ? 1 : 0);
    const normalizedSearchKeyMap = React.useMemo(() => {
        const mapping = {};
        searchKeys.forEach((key) => {
            mapping[normalizeKey(key)] = key;
        });
        return mapping;
    }, [searchKeys]);

    const getSystemFieldLabel = (value, label) => {
        return value && String(value).trim() ? label : "";
    };

    const parseUploadDateRangeForApi = (value) => {
        const inputValue = String(value || "").trim();
        if (!inputValue || !inputValue.includes(" - ")) {
            return null;
        }

        const [fromDate, toDate] = inputValue.split(" - ").map((item) => item.trim());
        const convertToIso = (dateStr) => {
            const parts = dateStr.split("/");
            if (parts.length !== 3) {
                return null;
            }
            const [day, month, year] = parts;
            if (!day || !month || !year) {
                return null;
            }
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        };

        const from = convertToIso(fromDate);
        const to = convertToIso(toDate);

        if (!from || !to) {
            return null;
        }

        return { from, to };
    };

    const uploadedByDisplayValue = uploadedBySelectedUsers.length > 0
        ? `${uploadedBySelectedUsers.length} Selected`
        : "";

    const filteredUploadedByOptions = React.useMemo(() => {
        const searchValue = uploadedBySearchText.trim().toLowerCase();
        if (!searchValue) {
            return uploadedByOptions;
        }
        return uploadedByOptions.filter((option) => option.toLowerCase().includes(searchValue));
    }, [uploadedByOptions, uploadedBySearchText]);

    const filteredDocumentTypeOptions = React.useMemo(() => {
        const searchValue = documentTypeSearchText.trim().toLowerCase();
        if (!searchValue) {
            return types;
        }
        return types.filter((option) => option.toLowerCase().includes(searchValue));
    }, [types, documentTypeSearchText]);

    const documentTypeMenuProps = React.useMemo(() => ({
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        classes: { paper: classes.documentTypeMenuPaper },
        MenuListProps: {
            className: classes.documentTypeMenuList
        }
    }), [classes.documentTypeMenuList, classes.documentTypeMenuPaper]);

    const resolvedSystemFieldMap = React.useMemo(() => {
        return systemFields.reduce((acc, field) => {
            const matchedNormalized = field.aliases.find((alias) => normalizedSearchKeyMap[alias]);
            if (matchedNormalized) {
                acc[field.id] = normalizedSearchKeyMap[matchedNormalized];
            }
            return acc;
        }, {});
    }, [normalizedSearchKeyMap]);

    const refineSearchKeys = React.useMemo(() => {
        const defaultKeySet = new Set(Object.values(resolvedSystemFieldMap));
        return searchKeys.filter((key) => !defaultKeySet.has(key));
    }, [searchKeys, resolvedSystemFieldMap]);


    const handleSearch = (
        pageSize = rowsPerPage,
        currentPage = 0,
        sortBy = orderBy,
        sortOrder = order,
        filters = {}
    ) => {
        setBackdrop(true);
        let sampleDocuments = [];
        setSelectedDocuments(new Set());
        setSelectedDocumentsFileId(new Set());
        const requestObj = {};
        requestObj.searchFilters=[];

        let queryParams = {
            '_page' : currentPage + 1,
            '_limit' : pageSize,
            
        }

        if (documentType.length > 0){
            queryParams['_documentType'] = documentType.map((type) => String(type).toLowerCase()).join(",");
        }

        if (sortBy && sortOrder){
            queryParams['_sort'] = sortBy;
            queryParams['_order'] = sortOrder;
        }

        if (filters){
            queryParams = {...queryParams , ...filters}
        }

        if (systemFieldValues.document_name && systemFieldValues.document_name.trim().length >= 1) {
            queryParams["_name"] = systemFieldValues.document_name.trim();
        }

        if (systemFieldValues.uploaded_by && systemFieldValues.uploaded_by.trim().length >= 1) {
            queryParams["_uploadedBy"] = systemFieldValues.uploaded_by
                .split(",")
                .map((value) => value.trim())
                .filter(Boolean)
                .join(",");
        }

        const uploadDateRangeFilter = parseUploadDateRangeForApi(systemFieldValues.upload_date);
        if (uploadDateRangeFilter) {
            requestObj.rangeFilters = [
                {
                    field: "store_datetime",
                    from: uploadDateRangeFilter.from,
                    to: uploadDateRangeFilter.to
                }
            ];
        }

        Object.keys(searchValues).forEach((key) => {
            if (searchValues[key].length>=1){
              requestObj.searchFilters.push({"field": key , "value" : searchValues[key]});
            }
        });

        DocuwareTemplateService.searchDocuments(requestObj,queryParams).then(response => {
            let searchDocumentsResponse = response.data;
            let totalCount = response.headers['x-total-count'];
            let sampleDocuments = searchDocumentsResponse;

            if(!sampleDocuments.length) {
                setDocuments(sampleDocuments);
                setQueryCount(totalCount);
                setSelectedDocuments(new Set());
                setSelectedDocumentsFileId(new Set());
                setSearchTriggered(true);
                setSearchPanelExpanded(false);
                notify({
                    type: "error",
                    message: "No documents are available for provided filters"
                });
            } else {
                setDocuments(sampleDocuments);
                setQueryCount(totalCount);
                setSelectedDocuments(new Set());
                setSelectedDocumentsFileId(new Set());
                setSearchTriggered(true);
                setSearchPanelExpanded(false);
            }
            setBackdrop(false);

        }).catch(error => {
            notify({
              type: 'error',
              message: 'Error Searching the documents'
            });
             setBackdrop(false);

        });
        
    }

    const isSearchDisabled = (documentType.length === 0 && transformedRefineValues.length === 0 && transformedSystemValues.length === 0);

    const resetSearchValues = () => {
        const resetValues = {};
        setSearchValues(resetValues);
        setSystemFieldValues({
            document_name: "",
            uploaded_by: "",
            upload_date: ""
        });
        setUploadDateRange([
            {
                startDate: new Date(),
                endDate: new Date(),
                key: "selection"
            }
        ]);
        setUploadDateAnchorEl(null);
        setDocumentNameAnchorEl(null);
        setDocumentNameOptions([]);
        setUploadedByAnchorEl(null);
        setUploadedBySelectedUsers([]);
        setUploadedBySearchText("");
        setDocumentType([]);
        setDocumentTypeSearchText("");
        setDocuments([]);
        setQueryCount(0);
        setSelectedDoc(null);
        setSelectedDocuments(new Map());
        setSelectedDocumentsFileId(new Set());
        setPage(0);
        setOrder("asc");
        setOrderBy("");
        setSearchTriggered(false);
        setSearchPanelExpanded(true);
    };

    const openResetConfirmDialog = () => {
        setIsResetConfirmOpen(true);
    };

    const closeResetConfirmDialog = () => {
        setIsResetConfirmOpen(false);
    };

    const handleConfirmResetSearch = () => {
        resetSearchValues();
        closeResetConfirmDialog();
    };

    const handleOpenUploadDatePicker = (event) => {
        setDocumentNameAnchorEl(null);
        setUploadedByAnchorEl(null);
        setUploadDateAnchorEl(event.currentTarget);
    };

    const handleCloseUploadDatePicker = () => {
        setUploadDateAnchorEl(null);
    };

    const handleUploadDateSelect = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setUploadDateRange([ranges.selection]);
        setSystemFieldValues((prev) => ({
            ...prev,
            upload_date: `${dayjs(startDate).format("DD/MM/YYYY")} - ${dayjs(endDate).format("DD/MM/YYYY")}`
        }));
        setUploadDateAnchorEl(null);
    };

    const handleChangeDocumentType = (event) => {
        const value = event.target.value;
        setDocumentType(typeof value === "string" ? value.split(",").filter(Boolean) : value);
    };

    const handleToggleAllDocumentTypes = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (filteredDocumentTypeOptions.length === 0) {
            return;
        }
        const areAllVisibleSelected = filteredDocumentTypeOptions.every((option) => documentType.includes(option));
        const nextTypes = areAllVisibleSelected
            ? documentType.filter((option) => !filteredDocumentTypeOptions.includes(option))
            : Array.from(new Set([...documentType, ...filteredDocumentTypeOptions]));
        setDocumentType(nextTypes);
    };

    const updateRecentDocumentSearches = (value) => {
        const normalizedValue = String(value || "").trim();
        if (!normalizedValue) {
            return;
        }
        setRecentDocumentSearches((previousValues) => {
            const nextValues = [normalizedValue, ...previousValues.filter((item) => item !== normalizedValue)].slice(0, 5);
            try {
                localStorage.setItem("docui_recent_document_searches", JSON.stringify(nextValues));
            } catch (error) {
                // no-op for environments where storage is unavailable
            }
            return nextValues;
        });
    };

    const fetchDocumentNameOptions = async (searchTerm, pageNumber = 1, pageSize = 10) => {
        const trimmedSearchTerm = String(searchTerm || "").trim();
        if (trimmedSearchTerm.length < 3) {
            setDocumentNameOptions([]);
            return;
        }
        setDocumentNameLoading(true);
        try {
            const response = await DocuwareTemplateService.getDocumentFieldValues("document_name", {
                _page: pageNumber,
                _limit: pageSize,
                _order: "asc",
                _search: trimmedSearchTerm
            });
            const payload = response?.data;
            const values = Array.isArray(payload)
                ? payload
                : Array.isArray(payload?.values)
                    ? payload.values
                    : [];
            const normalizedValues = values.map((value) => String(value).trim()).filter(Boolean);
            setDocumentNameOptions(Array.from(new Set(normalizedValues)));
        } catch (error) {
            setDocumentNameOptions([]);
        } finally {
            setDocumentNameLoading(false);
        }
    };

    const handleDocumentNameInputChange = (event) => {
        const value = event.target.value;
        setSystemFieldValues((previousValues) => ({
            ...previousValues,
            document_name: value
        }));
        const trimmedValue = value.trim();
        if (trimmedValue.length >= 3) {
            setUploadDateAnchorEl(null);
            setUploadedByAnchorEl(null);
            setDocumentNameAnchorEl(event.currentTarget);
        } else {
            setDocumentNameAnchorEl(null);
            setDocumentNameOptions([]);
        }
    };

    const handleClearDocumentName = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setSystemFieldValues((previousValues) => ({
            ...previousValues,
            document_name: ""
        }));
        setDocumentNameAnchorEl(null);
        setDocumentNameOptions([]);
    };

    const handleSelectDocumentName = (name) => {
        setSystemFieldValues((previousValues) => ({
            ...previousValues,
            document_name: name
        }));
        updateRecentDocumentSearches(name);
        setDocumentNameAnchorEl(null);
        setDocumentNameOptions([]);
        setDocumentNameLoading(false);
    };

    const handleCloseDocumentNamePicker = () => {
        setDocumentNameAnchorEl(null);
    };

    const fetchUploadedByOptions = async (pageNumber = 1, pageSize = 50, searchTerm = "") => {
        setUploadedByLoading(true);
        try {
            const trimmedSearchTerm = String(searchTerm || "").trim();
            const response = await DocuwareTemplateService.getDocumentFieldValues("uploaded_by", {
                _page: pageNumber,
                _limit: pageSize,
                _order: "asc",
                ...(trimmedSearchTerm ? { _search: trimmedSearchTerm } : {})
            });
            const payload = response?.data;
            const values = Array.isArray(payload)
                ? payload
                : Array.isArray(payload?.values)
                    ? payload.values
                    : [];
            const normalizedValues = values.map((value) => String(value).trim()).filter(Boolean);
            setUploadedByOptions(Array.from(new Set(normalizedValues)));
        } catch (error) {
            setUploadedByOptions([]);
        } finally {
            setUploadedByLoading(false);
        }
    };

    const handleOpenUploadedByPicker = (event) => {
        setDocumentNameAnchorEl(null);
        setUploadDateAnchorEl(null);
        setUploadedByAnchorEl(event.currentTarget);
        fetchUploadedByOptions(1, 50, uploadedBySearchText);
    };

    const handleCloseUploadedByPicker = () => {
        setUploadedByAnchorEl(null);
        setUploadedBySearchText("");
    };

    const handleToggleUploadedBy = (user) => {
        setUploadedBySelectedUsers((previousUsers) => {
            const nextUsers = previousUsers.includes(user)
                ? previousUsers.filter((item) => item !== user)
                : [...previousUsers, user];
            setSystemFieldValues((previousValues) => ({
                ...previousValues,
                uploaded_by: nextUsers.join(",")
            }));
            return nextUsers;
        });
    };

    const handleToggleAllUploadedBy = () => {
        const visibleOptions = filteredUploadedByOptions;
        if (!visibleOptions.length) {
            return;
        }
        const allVisibleSelected = visibleOptions.every((option) => uploadedBySelectedUsers.includes(option));
        const nextUsers = allVisibleSelected
            ? uploadedBySelectedUsers.filter((option) => !visibleOptions.includes(option))
            : Array.from(new Set([...uploadedBySelectedUsers, ...visibleOptions]));
        setUploadedBySelectedUsers(nextUsers);
        setSystemFieldValues((previousValues) => ({
            ...previousValues,
            uploaded_by: nextUsers.join(",")
        }));
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        handleSearch(rowsPerPage, newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        handleSearch(+event.target.value, 0);
    };

    const fetchSearchKeys = () => {
        DocuwareTemplateService.getSearchKeys().then(response => {
            let searchKeysResponse = response.data;

            searchKeysResponse =searchKeysResponse.map(field => field.name);
            setSearchKeys(searchKeysResponse);
          }).catch(error => {
            notify({
              type: 'error',
              message: 'Error fetching the search fields'
            });
        })

        DocuwareTemplateService.getAllTemplates(null).then(response => {
            let templateResponse = response.data;
            templateResponse = templateResponse ? templateResponse.documentTypes : [];
            templateResponse = templateResponse.map(template => (template.name));
            setTypes(templateResponse);
        }).catch(error => {
            notify({
              type: 'error',
              message: 'Error fetching the document types'
            });
        });

        DocuwareTemplateService.getClientFields().then(response => {
            let clientFieldResponse = response.data;
            // Filter out alias fields (fields with parentFieldId) - only show canonical fields
            clientFieldResponse = clientFieldResponse.filter(field => 
              !field.parentFieldId && !field.parent_field_id
            );
            setClientFields(clientFieldResponse);
          }).catch(error => {
            notify({
              type: 'error',
              message: 'Error fetching the field columns'
            });
        })
    }
    useEffect(() => {
        fetchSearchKeys();
        setDocuments([]);
        setSelectedDoc(null);
        setSearchTriggered(false);
        setDocumentType([]);
        setDocumentTypeSearchText("");
        setSearchPanelExpanded(true);
        setSystemFieldValues({
            document_name: "",
            uploaded_by: "",
            upload_date: ""
        });
        try {
            const storedRecentSearches = JSON.parse(localStorage.getItem("docui_recent_document_searches") || "[]");
            if (Array.isArray(storedRecentSearches) && storedRecentSearches.length) {
                setRecentDocumentSearches(storedRecentSearches.slice(0, 5).map((item) => String(item)));
            } else {
                setRecentDocumentSearches([
                    "Daily Financial Update.pdf",
                    "Daily Invoice Management.pdf",
                    "Daily Meeting Cadence.pdf",
                    "Daily Transactional Update.pdf",
                    "Daily Transport Update.pdf"
                ]);
            }
        } catch (error) {
            setRecentDocumentSearches([
                "Daily Financial Update.pdf",
                "Daily Invoice Management.pdf",
                "Daily Meeting Cadence.pdf",
                "Daily Transactional Update.pdf",
                "Daily Transport Update.pdf"
            ]);
        }
        setDocumentNameAnchorEl(null);
        setDocumentNameOptions([]);
        setUploadedBySelectedUsers([]);
        setUploadedBySearchText("");
        setUploadedByAnchorEl(null);
    }, [currentCompany])

    useEffect(() => {
        // Prevent stale anchor references when switching layouts/states.
        setUploadDateAnchorEl(null);
        setDocumentNameAnchorEl(null);
        setUploadedByAnchorEl(null);
    }, [searchTriggered]);

    useEffect(() => {
        const searchTerm = systemFieldValues.document_name?.trim() || "";
        if (!documentNameAnchorEl || searchTerm.length < 3) {
            return;
        }
        const debounceTimer = setTimeout(() => {
            fetchDocumentNameOptions(searchTerm);
        }, 300);
        return () => clearTimeout(debounceTimer);
    }, [systemFieldValues.document_name, documentNameAnchorEl]);

    useEffect(() => {
        if (!uploadedByAnchorEl) {
            return;
        }
        const debounceTimer = setTimeout(() => {
            fetchUploadedByOptions(1, 50, uploadedBySearchText);
        }, 300);
        return () => clearTimeout(debounceTimer);
    }, [uploadedBySearchText, uploadedByAnchorEl]);
    return (
        <div className={classes.searchPageRoot}>
            <Backdrop open={backdrop} style={{ color: "primary", zIndex: 1000000 }} >
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                !searchTriggered && (
                    <Paper className={classes.searchShell} elevation={0}>
                        <div className={classes.searchHeaderRow}>
                            <Box className={classes.searchHeaderTitle}>
                                <Typography className={classes.searchTitle}>Search</Typography>
                                {activeFiltersCount > 0 && (
                                    <Chip
                                        label={`${activeFiltersCount} active filter${activeFiltersCount > 1 ? "s" : ""}`}
                                        size="small"
                                        className={classes.filterChip}
                                    />
                                )}
                            </Box>
                            <IconButton
                                className={`${classes.searchHeaderIcon} ${classes.searchSummaryToggleIcon}`}
                                onClick={() => setSearchPanelExpanded((prev) => !prev)}
                            >
                                {searchPanelExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </div>
                        <Collapse in={searchPanelExpanded}>
                        <div className={classes.searchFieldsContainer}>
                            <div className={classes.defaultFieldsContainer}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <div className={classes.systemFieldWrapper}>
                                            <Typography className={classes.systemFieldTopLabel}>
                                                {getSystemFieldLabel(systemFieldValues.document_name, "Document Name")}
                                            </Typography>
                                            <TextField
                                                placeholder="Document Name"
                                                type="text"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                className={`${classes.systemTextField} ${classes.documentNameTextField}`}
                                                value={systemFieldValues.document_name}
                                                onChange={handleDocumentNameInputChange}
                                                onFocus={(event) => {
                                                    setDocumentNameAnchorEl(event.currentTarget);
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {Boolean(systemFieldValues.document_name?.trim()) ? (
                                                                <Box className={classes.documentNameAdornment}>
                                                                    <IconButton
                                                                        className={classes.documentNameClearButton}
                                                                        onMouseDown={(event) => event.preventDefault()}
                                                                        onClick={handleClearDocumentName}
                                                                    >
                                                                        <HighlightOffIcon className={classes.documentNameClearIcon} />
                                                                    </IconButton>
                                                                    <KeyboardArrowDownIcon className={classes.documentNameIcon} />
                                                                </Box>
                                                            ) : (
                                                                <SearchIcon className={classes.documentNameIcon} />
                                                            )}
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <div className={classes.systemFieldWrapper}>
                                            <Typography className={classes.systemFieldTopLabel}>
                                                {getSystemFieldLabel(systemFieldValues.uploaded_by, "Uploaded By")}
                                            </Typography>
                                            <TextField
                                                placeholder="Uploaded By"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                className={`${classes.systemTextField} ${classes.uploadedByTextField}`}
                                                value={uploadedByDisplayValue}
                                                onClick={handleOpenUploadedByPicker}
                                                InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <KeyboardArrowDownIcon className={classes.uploadedByIcon} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <div className={classes.systemFieldWrapper}>
                                            <Typography className={classes.systemFieldTopLabel}>
                                                {getSystemFieldLabel(systemFieldValues.upload_date, "Upload Date")}
                                            </Typography>
                                            <TextField
                                                placeholder="Upload Date"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                className={`${classes.systemTextField} ${classes.uploadDateTextField}`}
                                                value={systemFieldValues.upload_date}
                                                onClick={handleOpenUploadDatePicker}
                                                InputProps={{
                                                    readOnly: true,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <CalendarTodayIcon className={classes.uploadDateIcon} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <div className={classes.systemFieldWrapper}>
                                            <Typography className={classes.systemFieldTopLabel}>
                                                {getSystemFieldLabel(documentType.join(", "), "Document Type")}
                                            </Typography>
                                            <TextField
                                                select
                                                type="text"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                className={classes.systemTextField}
                                                value={documentType}
                                                onChange={handleChangeDocumentType}
                                                SelectProps={{
                                                    multiple: true,
                                                    displayEmpty: true,
                                                    onClose: () => setDocumentTypeSearchText(""),
                                                    renderValue: (selected) => {
                                                        if (!selected || selected.length === 0) {
                                                            return "Document Type";
                                                        }
                                                        return selected.join(", ");
                                                    },
                                                    MenuProps: documentTypeMenuProps
                                                }}
                                            >
                                                <MenuItem
                                                    disableRipple
                                                    className={classes.documentTypeMenuSearchItem}
                                                    onClick={(event) => {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                    }}
                                                >
                                                    <TextField
                                                        placeholder="Search From List *"
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        value={documentTypeSearchText}
                                                        onChange={(event) => setDocumentTypeSearchText(event.target.value)}
                                                        className={classes.documentTypeMenuSearchField}
                                                        onClick={(event) => event.stopPropagation()}
                                                    />
                                                </MenuItem>
                                                <MenuItem className={classes.documentTypeMenuItem} onClick={handleToggleAllDocumentTypes}>
                                                    <Checkbox
                                                        checked={
                                                            filteredDocumentTypeOptions.length > 0 &&
                                                            filteredDocumentTypeOptions.every((option) => documentType.includes(option))
                                                        }
                                                        indeterminate={
                                                            filteredDocumentTypeOptions.some((option) => documentType.includes(option)) &&
                                                            !filteredDocumentTypeOptions.every((option) => documentType.includes(option))
                                                        }
                                                        color="primary"
                                                        className={classes.documentTypeMenuCheckbox}
                                                    />
                                                    Select All
                                                </MenuItem>
                                                {filteredDocumentTypeOptions.map((type) => (
                                                    <MenuItem key={type} value={type} className={classes.documentTypeMenuItem}>
                                                        <Checkbox
                                                            checked={documentType.includes(type)}
                                                            color="primary"
                                                            className={classes.documentTypeMenuCheckbox}
                                                        />
                                                        {type}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                            {refineSearchKeys.length > 0 && (
                                <div className={classes.refineSectionBlock}>
                                    <div className={classes.refineToggleRow}>
                                                <IconButton
                                                    className={classes.refineToggleIconButton}
                                                    onClick={() => setRefineExpanded((prev) => !prev)}
                                                >
                                                    {refineExpanded ? <RemoveCircleOutlineIcon /> : <ExpandMoreIcon />}
                                                </IconButton>
                                        <Button
                                            className={classes.refineToggleButton}
                                            onClick={() => setRefineExpanded((prev) => !prev)}
                                        >
                                            Refine Search
                                        </Button>
                                        <Divider className={classes.refineDivider} />
                                    </div>
                                    <Collapse in={refineExpanded}>
                                        <div className={classes.refineFieldsContainer}>
                                            <Grid container spacing={2}>
                                                {refineSearchKeys.map((key) => {
                                                    const normalizedKey = normalizeKey(key);
                                                    return (
                                                        <Grid item xs={12} sm={6} md={3} key={normalizedKey}>
                                                            <TextField
                                                                placeholder={key}
                                                                type="text"
                                                                variant="outlined"
                                                                fullWidth
                                                                size="small"
                                                                className={classes.refineTextField}
                                                                value={searchValues[normalizedKey] || ''}
                                                                onChange={(e) =>
                                                                    setSearchValues((prev) => ({
                                                                        ...prev,
                                                                        [normalizedKey]: e.target.value,
                                                                    }))
                                                                }
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    </Collapse>
                                </div>
                            )}
                        </div>

                        <div className={classes.searchActionBar}>
                            <Button
                                onClick={openResetConfirmDialog}
                                variant="outlined"
                                color="primary"
                                className={classes.secondaryActionButton}
                                startIcon={<AutorenewIcon />}
                            >
                                Reset All
                            </Button>
                            <Button
                                onClick={() => (handleSearch())}
                                disabled={isSearchDisabled}
                                variant="contained"
                                className={classes.primaryActionButton}
                            >
                                Search
                            </Button>
                        </div>
                        </Collapse>
                    </Paper>
                )
            }
            {searchTriggered && (
                <>
                    <Backdrop open={backdrop} style={{ color: "primary", zIndex: 1000000 }} >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <div className={classes.resultsPageRoot}>
                        <Paper className={classes.searchShell} elevation={0}>
                            <div className={classes.searchHeaderRow}>
                                <Box className={classes.searchHeaderTitle}>
                                    <Typography className={classes.searchTitle}>Search</Typography>
                                    {activeFiltersCount > 0 && (
                                        <Chip
                                            label={`${activeFiltersCount} Filters applied`}
                                            size="small"
                                            className={classes.filterChip}
                                        />
                                    )}
                                </Box>
                                <Box className={classes.searchHeaderActions}>
                                    {activeFiltersCount > 0 && (
                                        <Button
                                            onClick={openResetConfirmDialog}
                                            className={classes.resetSearchLink}
                                            startIcon={<AutorenewIcon />}
                                        >
                                            Reset Search
                                        </Button>
                                    )}
                                    <IconButton
                                        className={`${classes.searchHeaderIcon} ${classes.searchSummaryToggleIcon}`}
                                        onClick={() => setSearchPanelExpanded((prev) => !prev)}
                                    >
                                        {searchPanelExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    </IconButton>
                                </Box>
                            </div>
                            <Collapse in={searchPanelExpanded}>
                                <div className={classes.searchFieldsContainer}>
                                    <div className={classes.defaultFieldsContainer}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <div className={classes.systemFieldWrapper}>
                                                    <Typography className={classes.systemFieldTopLabel}>
                                                        {getSystemFieldLabel(systemFieldValues.document_name, "Document Name")}
                                                    </Typography>
                                                    <TextField
                                                        placeholder="Document Name"
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        className={`${classes.systemTextField} ${classes.documentNameTextField}`}
                                                        value={systemFieldValues.document_name}
                                                        onChange={handleDocumentNameInputChange}
                                                        onFocus={(event) => {
                                                            setDocumentNameAnchorEl(event.currentTarget);
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {Boolean(systemFieldValues.document_name?.trim()) ? (
                                                                        <Box className={classes.documentNameAdornment}>
                                                                            <IconButton
                                                                                className={classes.documentNameClearButton}
                                                                                onMouseDown={(event) => event.preventDefault()}
                                                                                onClick={handleClearDocumentName}
                                                                            >
                                                                                <HighlightOffIcon className={classes.documentNameClearIcon} />
                                                                            </IconButton>
                                                                            <KeyboardArrowDownIcon className={classes.documentNameIcon} />
                                                                        </Box>
                                                                    ) : (
                                                                        <SearchIcon className={classes.documentNameIcon} />
                                                                    )}
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <div className={classes.systemFieldWrapper}>
                                                    <Typography className={classes.systemFieldTopLabel}>
                                                        {getSystemFieldLabel(systemFieldValues.uploaded_by, "Uploaded By")}
                                                    </Typography>
                                                    <TextField
                                                        placeholder="Uploaded By"
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        className={`${classes.systemTextField} ${classes.uploadedByTextField}`}
                                                        value={uploadedByDisplayValue}
                                                        onClick={handleOpenUploadedByPicker}
                                                        InputProps={{
                                                            readOnly: true,
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <KeyboardArrowDownIcon className={classes.uploadedByIcon} />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <div className={classes.systemFieldWrapper}>
                                                    <Typography className={classes.systemFieldTopLabel}>
                                                        {getSystemFieldLabel(systemFieldValues.upload_date, "Upload Date")}
                                                    </Typography>
                                                    <TextField
                                                        placeholder="Upload Date"
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        className={`${classes.systemTextField} ${classes.uploadDateTextField}`}
                                                        value={systemFieldValues.upload_date}
                                                        onClick={handleOpenUploadDatePicker}
                                                        InputProps={{
                                                            readOnly: true,
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <CalendarTodayIcon className={classes.uploadDateIcon} />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <div className={classes.systemFieldWrapper}>
                                                    <Typography className={classes.systemFieldTopLabel}>
                                                        {getSystemFieldLabel(documentType.join(", "), "Document Type")}
                                                    </Typography>
                                                    <TextField
                                                        select
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        className={classes.systemTextField}
                                                        value={documentType}
                                                        onChange={handleChangeDocumentType}
                                                        SelectProps={{
                                                            multiple: true,
                                                            displayEmpty: true,
                                                            onClose: () => setDocumentTypeSearchText(""),
                                                            renderValue: (selected) => {
                                                                if (!selected || selected.length === 0) {
                                                                    return "Document Type";
                                                                }
                                                                return selected.join(", ");
                                                            },
                                                            MenuProps: documentTypeMenuProps
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disableRipple
                                                            className={classes.documentTypeMenuSearchItem}
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                            }}
                                                        >
                                                            <TextField
                                                                placeholder="Search From List *"
                                                                variant="outlined"
                                                                fullWidth
                                                                size="small"
                                                                value={documentTypeSearchText}
                                                                onChange={(event) => setDocumentTypeSearchText(event.target.value)}
                                                                className={classes.documentTypeMenuSearchField}
                                                                onClick={(event) => event.stopPropagation()}
                                                            />
                                                        </MenuItem>
                                                        <MenuItem className={classes.documentTypeMenuItem} onClick={handleToggleAllDocumentTypes}>
                                                            <Checkbox
                                                                checked={
                                                                    filteredDocumentTypeOptions.length > 0 &&
                                                                    filteredDocumentTypeOptions.every((option) => documentType.includes(option))
                                                                }
                                                                indeterminate={
                                                                    filteredDocumentTypeOptions.some((option) => documentType.includes(option)) &&
                                                                    !filteredDocumentTypeOptions.every((option) => documentType.includes(option))
                                                                }
                                                                color="primary"
                                                                className={classes.documentTypeMenuCheckbox}
                                                            />
                                                            Select All
                                                        </MenuItem>
                                                        {filteredDocumentTypeOptions.map((type) => (
                                                            <MenuItem key={type} value={type} className={classes.documentTypeMenuItem}>
                                                                <Checkbox
                                                                    checked={documentType.includes(type)}
                                                                    color="primary"
                                                                    className={classes.documentTypeMenuCheckbox}
                                                                />
                                                                {type}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                    {refineSearchKeys.length > 0 && (
                                        <div className={classes.refineSectionBlock}>
                                            <div className={classes.refineToggleRow}>
                                                <IconButton
                                                    className={classes.refineToggleIconButton}
                                                    onClick={() => setRefineExpanded((prev) => !prev)}
                                                >
                                                    {refineExpanded ? <RemoveCircleOutlineIcon /> : <ExpandMoreIcon />}
                                                </IconButton>
                                                <Button
                                                    className={classes.refineToggleButton}
                                                    onClick={() => setRefineExpanded((prev) => !prev)}
                                                >
                                                    Refine Search
                                                </Button>
                                                <Divider className={classes.refineDivider} />
                                            </div>
                                            <Collapse in={refineExpanded}>
                                                <div className={classes.refineFieldsContainer}>
                                                    <Grid container spacing={2}>
                                                        {refineSearchKeys.map((key) => {
                                                            const normalizedKey = normalizeKey(key);
                                                            return (
                                                                <Grid item xs={12} sm={6} md={3} key={normalizedKey}>
                                                                    <TextField
                                                                        placeholder={key}
                                                                        type="text"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        size="small"
                                                                        className={classes.refineTextField}
                                                                        value={searchValues[normalizedKey] || ''}
                                                                        onChange={(e) =>
                                                                            setSearchValues((prev) => ({
                                                                                ...prev,
                                                                                [normalizedKey]: e.target.value,
                                                                            }))
                                                                        }
                                                                    />
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Grid>
                                                </div>
                                            </Collapse>
                                        </div>
                                    )}
                                </div>

                                <div className={classes.searchActionBar}>
                                    <Button
                                        onClick={openResetConfirmDialog}
                                        variant="outlined"
                                        color="primary"
                                        className={classes.secondaryActionButton}
                                        startIcon={<AutorenewIcon />}
                                    >
                                        Reset All
                                    </Button>
                                    <Button
                                        onClick={() => (handleSearch())}
                                        disabled={isSearchDisabled}
                                        variant="contained"
                                        className={classes.primaryActionButton}
                                    >
                                        Search
                                    </Button>
                                </div>
                            </Collapse>
                        </Paper>
                        <Typography className={classes.resultsInfoText}>
                            {systemFieldValues.document_name?.trim()
                                ? `Showing ${queryCount} results for "${systemFieldValues.document_name.trim()}"`
                                : `Showing ${queryCount} results`}
                        </Typography>
                        <Grid container spacing={3} wrap="wrap" className={classes.resultsGrid}>
                        <Grid item xs={12} md={(selectedDoc && selectedDocuments && selectedDocuments.size<=1) ? 6 : 12} className={classes.resultsLeftPane}>
                            <Fade in timeout={500}>
                                <Paper
                                    className={`${classes.resultShell} ${viewType !== 'grid' ? classes.resultWhite : classes.resultZebra}`}
                                >
                                    {viewType==='grid' ? 
                                    <div display='flex'>
                                    <Grid
                                        container
                                        spacing={3}              
                                        justifyContent="flex-start"
                                        alignItems="stretch">
                                            <DocumentGrid
                                            documents={documents}
                                            placeholderImage={placeholderImage}
                                            onDocumentClick={handleDocumentClick}
                                            selectedDoc={selectedDoc}
                                            /> 
                                    </Grid>
                                    <PaginationRoot
                                    queryCount={queryCount}
                                    page={page}
                                    handleChangePage={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    handleChangeRowsPerPage={handleChangeRowsPerPage}/>
                                    </div>
                                    :
                                        
                                    <DocumentTabularView 
                                        rows={documents}
                                        onDocumentClick={handleDocumentClick}
                                        orderBy = {orderBy}
                                        order = {order}
                                        queryCount={queryCount}
                                        page={page}
                                        handleChangePage={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                                        handleMultipleFileSelect={handleSelectedDocs}
                                        selectedDocuments={selectedDocuments}
                                        selectedDocumentsFileId={selectedDocumentsFileId}
                                        setBackdrop = {setBackdrop}
                                        clientFields = {clientFields}
                                        handleRequestSort={handleRequestSort}
                                        handleFilterSearch = {handleFilterSearch}
                                        documentTypes={documentType.length > 0 ? documentType : types}
                                        allDocumentTypes = {types}
                                        showLocationColumn={true}
                                    />}
                                </Paper>
                            </Fade>
                        </Grid>
                        {(selectedDoc && selectedDocuments && selectedDocuments.size<=1) && (
                        <Grid item xs={12} md={6} className={classes.resultsRightPane}>
                            <Paper
                                elevation={3}
                                className={classes.previewPane}
                            >
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    mb={2} // margin bottom
                                >
                                    <Typography variant="h6" noWrap>
                                        {documents.find((doc) => doc.id === selectedDoc)?.name}
                                    </Typography>
                                    <IconButton onClick={() => setSelectedDoc(null)}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <Fade in timeout={500}>
                                        
                                    <div
                                        className={classes.previewDocumentWrapper}
                                    >
                                        {/* {"provide fileurl to file here instead of path"} */}
                                        <PDFViewer file={selectedDoc.id} name={selectedDoc.name} extension={selectedDoc.extension}/>
                                    </div>
                                </Fade>
                            </Paper>
                        </Grid>
                        )}
                    </Grid>
                    </div>
                </>
            )}
            <Dialog
                open={isResetConfirmOpen}
                onClose={closeResetConfirmDialog}
                classes={{ paper: classes.resetSearchDialogPaper }}
                maxWidth={false}
            >
                <div className={classes.resetSearchDialogHeader}>
                    <div className={classes.resetSearchDialogTitleWrap}>
                        <Typography className={classes.resetSearchDialogTitle}>
                            Reset Search
                        </Typography>
                    </div>
                    <IconButton className={classes.resetSearchDialogCloseButton} onClick={closeResetConfirmDialog}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={classes.resetSearchDialogContent}>
                    <Typography className={classes.resetSearchDialogHint}>
                        Confirmation required
                    </Typography>
                    <Typography className={classes.resetSearchDialogMessage}>
                        Are you sure you want to reset this search? This cannot be undone.
                    </Typography>
                </div>
                <div className={classes.resetSearchDialogFooter}>
                    <Button
                        onClick={closeResetConfirmDialog}
                        className={classes.resetSearchDialogSecondaryButton}
                    >
                        Continue Searching
                    </Button>
                    <Button
                        onClick={handleConfirmResetSearch}
                        className={classes.resetSearchDialogPrimaryButton}
                    >
                        Reset Search
                    </Button>
                </div>
            </Dialog>
            <Popover
                open={Boolean(documentNameAnchorEl)}
                anchorEl={documentNameAnchorEl}
                onClose={handleCloseDocumentNamePicker}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                classes={{ paper: classes.documentNamePopoverPaper }}
            >
                <div className={classes.documentNamePopoverContainer}>
                    {(systemFieldValues.document_name || "").trim().length >= 3 ? (
                        documentNameLoading ? (
                            <Typography className={classes.documentNameEmptyState}>Loading suggestions...</Typography>
                        ) : documentNameOptions.length ? (
                            documentNameOptions.map((option) => (
                                <div
                                    key={option}
                                    className={classes.documentNameOptionRow}
                                    onClick={() => handleSelectDocumentName(option)}
                                >
                                    <Typography className={classes.documentNameOptionLabel}>{option}</Typography>
                                </div>
                            ))
                        ) : (
                            <Typography className={classes.documentNameEmptyState}>No document names found</Typography>
                        )
                    ) : (
                        <>
                            <Typography className={classes.documentNameRecentTitle}>Recent Searches</Typography>
                            {recentDocumentSearches.length ? (
                                recentDocumentSearches.map((option) => (
                                    <div
                                        key={option}
                                        className={classes.documentNameRecentRow}
                                        onClick={() => handleSelectDocumentName(option)}
                                    >
                                        <AccessTimeIcon className={classes.documentNameRecentIcon} />
                                        <Typography className={classes.documentNameOptionLabel}>{option}</Typography>
                                    </div>
                                ))
                            ) : (
                                <Typography className={classes.documentNameEmptyState}>No recent searches</Typography>
                            )}
                        </>
                    )}
                </div>
            </Popover>
            <Popover
                open={Boolean(uploadedByAnchorEl)}
                anchorEl={uploadedByAnchorEl}
                onClose={handleCloseUploadedByPicker}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                classes={{ paper: classes.uploadedByPopoverPaper }}
            >
                <div className={classes.uploadedByPopoverContainer}>
                    <TextField
                        placeholder="Search From List *"
                        value={uploadedBySearchText}
                        onChange={(event) => setUploadedBySearchText(event.target.value)}
                        variant="outlined"
                        fullWidth
                        size="small"
                        className={classes.uploadedBySearchInput}
                    />
                    <div className={classes.uploadedByOptionRow} onClick={handleToggleAllUploadedBy}>
                        <Checkbox
                            size="small"
                            checked={filteredUploadedByOptions.length > 0 && filteredUploadedByOptions.every((option) => uploadedBySelectedUsers.includes(option))}
                            indeterminate={
                                filteredUploadedByOptions.some((option) => uploadedBySelectedUsers.includes(option)) &&
                                !filteredUploadedByOptions.every((option) => uploadedBySelectedUsers.includes(option))
                            }
                            color="primary"
                        />
                        <Typography className={classes.uploadedByOptionLabel}>Select All</Typography>
                    </div>
                    <div className={classes.uploadedByOptionsList}>
                        {uploadedByLoading ? (
                            <Typography className={classes.uploadedByEmptyState}>Loading users...</Typography>
                        ) : filteredUploadedByOptions.length ? (
                            filteredUploadedByOptions.map((option) => (
                                <div
                                    key={option}
                                    className={`${classes.uploadedByOptionRow} ${uploadedBySelectedUsers.includes(option) ? classes.uploadedByOptionSelected : ""}`}
                                    onClick={() => handleToggleUploadedBy(option)}
                                >
                                    <Checkbox
                                        size="small"
                                        checked={uploadedBySelectedUsers.includes(option)}
                                        color="primary"
                                    />
                                    <Typography className={classes.uploadedByOptionLabel}>{option}</Typography>
                                </div>
                            ))
                        ) : (
                            <Typography className={classes.uploadedByEmptyState}>No users found</Typography>
                        )}
                    </div>
                </div>
            </Popover>
            <Popover
                open={Boolean(uploadDateAnchorEl)}
                anchorEl={uploadDateAnchorEl}
                onClose={handleCloseUploadDatePicker}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                classes={{ paper: classes.uploadDatePopoverPaper }}
            >
                <DateRange
                    onChange={handleUploadDateSelect}
                    ranges={uploadDateRange}
                    months={2}
                    direction="horizontal"
                    rangeColors={["#0080AF"]}
                    locale={enUS}
                    className="docuiSearchDateRangeWrapper"
                    showDateDisplay={false}
                    staticRanges={[]}
                    inputRanges={[]}
                    editableDateInputs
                    moveRangeOnFirstSelection={false}
                />
            </Popover>
        </div>
    )
}